import PrivacyPolicy from "@components/shared/legal/privacyPolicy";
import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import InsureYourCarWrapper from "@components/layouts/insureYourCarWrapper";

import { getPageProps } from "@services/initial-calls";

export default function FreeCreditEvaluationHome(): ReactElement {
    return (
        <InsureYourCarWrapper>
            <PrivacyPolicy className="max-w-7xl mx-auto" />
        </InsureYourCarWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
